import { Country } from '@/features/countries';

export type GenericObject = { [key: string]: any };
export type GO = GenericObject;

/**
 * Networkin exception info
 */
export type ErrorInfo = {
  code: number;
  message: string;
};

/**
 * Globaly used options including components
 */
export enum APP_PAGES {
  LOGIN = 'LOGIN_PAGE',
  HOME = 'HOME_PAGE',
  PROJECT = 'PROJECT_PAGE',
  DRAWING = 'DRAWING_PAGE',
}

/**
 * Application level type definition commonly used by each feature
 */

export type BaseEntity = {
  id: string;
  name: string;
  title: string;
  created_by: number;
  date_created: number;
  modified_by: number;
  date_modified: number;
};

export type User = {
  firstName: string;
  lastName: string;
  email: string;
  role: 'ADMIN' | 'USER';
  teamId: string;
  bio: string;
  createdAt: number;
} & BaseEntity;

export type ForgotPasswordDTO = {
  email: string;
};

export type PasswordResetValues = {
  password: string;
  confirmPassword: string;
};

export type PasswordResetDTO = {
  password: string;
  email: string;
  token: string;
  email_confirmed: number;
};

export type RegisterCredentialsDTO = {
  email: string;
  password: string;
  name: string;
};

export type LoginCredentialsDTO = {
  email: string;
  password: string;
};

export type RegisterValues = {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
  readTerms: boolean;
};

export type AuthResponse = {
  jwt: string;
  user: User;
};

/** TK user schema -> User -> BaseEntity */
export type AuthUser = {
  phone: string;
  phone_code?: string;
  email_confirmed: number;
  image_profile_path?: string;
  country: Country | null;
  /** 'ACTIVE' | 'CANCELED' */
  status: string | null;
  company_roles: CompanyRole[]; // @2023/09/19
  /** legal user for takeoff tool - @2026/05/20 */
  has_takeoff_tool: boolean;
  /** if receive ai job notification - @2026/09/04 */
  send_job_notifications: boolean;
} & User &
  BaseEntity;

export type Entity<T> = {
  [K in keyof T]: T[K];
} & PrimEntity;

export type PrimEntity = {
  id: string;
  createdAt: number;
};

export type Role = BaseObject & {
  role_type: string;
  permissions: BaseObject[];
};

export type CompanyRole = {
  company: BaseObject;
  roles: Role[];
};

/**
 * AuthUser with `token`
 */
export type UserResponse = AuthUser & {
  token?: string;
};

export type PasswordResetResponse = {
  token: string;
  email: string;
  expires_on: string;
  completed: number;
};

export type BaseObject = {
  id: number;
  name: string;
};

export type JobMessage = {
  /** AI job id */
  id: string;
  /** JOB_STATUS_CHANGE|JOB_PROGRESS_CHANGE */
  type: string;
  /** AI module name */
  name?: string;
  /** ai progress */
  progress?: number;
  /** job status */
  status?: string;
  /** total progress for the drawing - 2024/02/27 */
  overall_progress?: number;
};

export enum ROLES {
  ADMIN = 'ADMIN',
  USER = 'USER',
  PROJECT_OWNER = 'PROJECT_OWNER',
  PROJECT_CONTRIBUTOR = 'PROJECT_CONTRIBUTOR',
  PROJECT_VIEWER = 'PROJECT_VIEWER',
}
